<fuse-loading-bar></fuse-loading-bar>
<p-toast></p-toast>
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
